export interface CampaignPlatformApiItem {
  platform: string;
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
  utm_term?: string | null;
  landing_page_url?: string | null;
}

export interface CampaignSuccessPlatformLink {
  id: string;
  label: string;
  url: string;
}

const PLATFORM_LABELS: Record<string, string> = {
  facebook: 'Facebook',
  google: 'Google Ads',
  email: 'Email',
  sms: 'Text Messaging',
  mailer: 'Physical Mailer',
  physical_mailer: 'Physical Mailer',
};

function extractPlatformEntries(platforms: any): (string | CampaignPlatformApiItem)[] {
  if (!Array.isArray(platforms)) {
    return [];
  }
  return platforms
    .map((item: any) => {
      if (typeof item === 'string') {
        return item;
      }
      if (item && typeof item === 'object' && 'platform' in item) {
        return item as CampaignPlatformApiItem;
      }
      return null;
    })
    .filter((item): item is string | CampaignPlatformApiItem => item !== null);
}

function buildDefaultCampaignUrl(campaignId: string, platformId: string): string {
  const params = new URLSearchParams({
    campaign_id: campaignId,
    source: platformId,
  });
  return `/campaign?${params.toString()}`;
}

/**
 * Builds copyable platform links from GET campaign `platforms` (same shape as campaignData.platform).
 * Returns `[]` until the landing page exists (`landingReady`, see isCampaignLandingPageReady).
 */
export function buildCampaignSuccessPlatformLinks(
  campaignId: string,
  platforms: any,
  landingReady: boolean
): CampaignSuccessPlatformLink[] {
  if (!landingReady || !campaignId?.trim()) {
    return [];
  }

  return extractPlatformEntries(platforms)
    .map(entry => {
      const platformId = typeof entry === 'string' ? entry : entry.platform;
      const label = PLATFORM_LABELS[platformId] ?? platformId;
      const url = buildDefaultCampaignUrl(campaignId, platformId);

      return {
        id: platformId,
        label: `${label}*`,
        url,
      };
    })
    .filter(link => Boolean(link.id && link.url));
}
